import {
    CreateButton,
    Datagrid,
    DateField,
    ExportButton,
    List,
    ReferenceInput,
    SearchInput,
    SelectInput,
    TextField, TextInput,
    TopToolbar,
    useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';
import type { Client, ClientStatus } from '../../types';
import { TemplateChip } from './TemplateFields';

const clientFilters = [
    <SearchInput key="q" source="q" alwaysOn/>,
    <SelectInput
        alwaysOn
        key="status"
        source="status"
        choices={[
            { id: 'pending', name: 'Pending' },
            { id: 'active', name: 'Active' },
            { id: 'inactive', name: 'Inactive' },
        ]}
    />,
    <TextInput source="zenkyStoreId" alwaysOn />,
    // Feature 012
    <ReferenceInput key="templateKey" source="templateKey" reference="templates" alwaysOn>
        <SelectInput optionText="name" optionValue="key" label="Template"/>
    </ReferenceInput>,
    <TextInput key="coreVersion" source="coreVersion" label="Template version"/>,
];

// @ts-ignore
const StatusField = (props: any) => {
    const record = useRecordContext<Client>(props);
    if (!record) return null;

    const statusColors: Record<ClientStatus, 'default' | 'success' | 'warning'> = {
        pending: 'warning',
        active: 'success',
        inactive: 'default',
    };

    return (
        <Chip
            label={record.status}
            color={statusColors[record.status]}
            size="small"
        />
    );
};

StatusField.defaultProps = { label: 'Status' };

const ListActions = () => (
    <TopToolbar>
        <CreateButton/>
        <ExportButton/>
    </TopToolbar>
);

export const ClientList = () => (
    <List
        filters={clientFilters}
        actions={<ListActions/>}
        sort={{ field: 'createdAt', order: 'DESC' }}
    >
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="name"/>
            <TextField source="slug"/>
            <TextField source="zenkyStoreId" label="Zenky Store ID"/>
            <StatusField source="status"/>
            <TemplateChip label="Template"/>
            <DateField source="lastBuildAt" showTime/>
            <DateField source="createdAt" showTime/>
            <DateField source="updatedAt" showTime/>
            <TextField source="createdBy"/>
        </Datagrid>
    </List>
);
